"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var colors_1 = require("../colors");

var themes_1 = require("../themes");

exports.Magnifier = function (props) {
  var _a;

  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48"
  }, react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    fill: (_a = colors_1.getColor(props), _a !== null && _a !== void 0 ? _a : themes_1.defaultTheme.colors.default.onColor),
    id: "i-411",
    d: "M32.66,28.41C34.75,25.47,36,21.88,36,18c0-9.93-8.08-18-18-18C8.07,0,0,8.07,0,18c0,9.92,8.07,18,18,18 c3.88,0,7.47-1.25,10.41-3.34l14.76,14.75l4.24-4.24L32.66,28.41z M18,34C9.18,34,2,26.82,2,18C2,9.18,9.18,2,18,2 c8.82,0,16,7.18,16,16C34,26.82,26.82,34,18,34z"
  })), react_1.default.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-411"
  }));
};